import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPaymentGatewayOptionHint.ts
var t = () => e("paymentGatewayOptionHint");
//#endregion
export { t as useTrPaymentGatewayOptionHint };
